import { Injectable } from "@angular/core";
import { GoogleAnalyticsService } from "ngx-google-analytics";

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  constructor(private gaService: GoogleAnalyticsService) {
  }
  public SendEventGa(inEventCategory: string, inEventLabel: string | number, inEventAction: string, inEventValue: number = 0) {
      this.gaService.event(inEventAction, inEventCategory, String(inEventLabel), inEventValue);
    }
    public setGaService(gaService: GoogleAnalyticsService) {
      this.gaService = gaService;
    }
}